// extracted by mini-css-extract-plugin
export var borderRadius = "_a5-4";
export var large = "_a5-3";
export var logoContainer = "_a5-0";
export var nameLogo = "_a5-2";
export var small = "_a5-1";